import * as React from 'react';
import { Dropdown, Input } from 'semantic-ui-react';

import paisesOptions from './paisesOptions';

export interface PasaporteProps {
    pais?: string;
    pasaporte: string;
    requerido?: boolean;
    ocultarPais?: boolean;
    alCambiarPais?(pais: string): void;
    alCambiarPasaporte(pasaporte: string): void;
}

type PaisProps = Pick<PasaporteProps, 'pais' | 'ocultarPais' | 'alCambiarPais'>;

class Pais extends React.Component<PaisProps> {
    public shouldComponentUpdate(nextProps: PaisProps) {
        return (
            this.props.pais !== nextProps.pais || this.props.ocultarPais !== nextProps.ocultarPais
        );
    }

    public render() {
        const { ocultarPais, pais, alCambiarPais, ...otros } = this.props;

        return (
            !ocultarPais && (
                <Dropdown
                    {...otros}
                    options={paisesOptions}
                    value={pais}
                    onChange={(_e, { value }) => {
                        if (alCambiarPais) alCambiarPais(value as string);
                    }}
                    search
                    button
                    noResultsMessage='No hay resultados.'
                />
            )
        );
    }
}

export const Pasaporte: React.FunctionComponent<PasaporteProps> = props => {
    const {
        pais,
        pasaporte,
        requerido = false,
        ocultarPais = false,
        alCambiarPais,
        alCambiarPasaporte,
    } = props;

    return (
        <Input
            placeholder='102008A'
            type='text'
            label={<Pais pais={pais} alCambiarPais={alCambiarPais} ocultarPais={ocultarPais} />}
            value={pasaporte}
            onChange={(_e, { value }) => {
                alCambiarPasaporte(formatearPasaporte(value));
            }}
            required={requerido}
        />
    );
};

function formatearPasaporte(texto: string) {
    const soloNumerosLetrasGuion = texto.replace(/[^\w\-]/g, '');
    return soloNumerosLetrasGuion.toUpperCase();
}

export default Pasaporte;



// WEBPACK FOOTER //
// ./src/modulos/Recepcion/TurnosYAtenciones/componentes/RutPasaporte/componentes/Pasaporte/index.tsx